import { useSelector, useDispatch } from 'react-redux';
import FJFake3dRight from './FJFake3dRight';
import FJActionFake3d from '../../../redux/action/FJActionFake3d';
import { setSliceIsDraggingFileAction } from '../../../redux/slices/FJSliceCommon';
import useLocalStore from '../../../hooks/useLocalStore';

const FJFake3dRightContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();

    const headerTabIndex = useSelector(state => state.common.headerTabIndex);
    const _setIsDraggingFile = value => {
        dispatch(setSliceIsDraggingFileAction(value));
    };
    const uploadImg = file => {
        dispatch(FJActionFake3d.uploadImageAction(file));
    };
    return (
        <FJFake3dRight headerTabIndex={headerTabIndex} setIsDraggingFile={_setIsDraggingFile} uploadImg={uploadImg} />
    );
};

export default FJFake3dRightContainer;
